// --- UI Toggling for Sign-In and Sign-Up Forms ---

// A function to switch which authentication view is visible.
function toggleAuthView(viewToShow) {
    const signinView = document.getElementById('signin-view');
    const signupView = document.getElementById('signup-view');

    if (!signinView || !signupView) {
        console.error('Authentication view containers not found. Cannot toggle.');
        return;
    }

    if (viewToShow === 'signup') {
        signinView.classList.add('is-hidden');
        signupView.classList.remove('is-hidden');
    } else { // Default to showing sign-in view
        signupView.classList.add('is-hidden');
        signinView.classList.remove('is-hidden');
    }
}

// This function sets up the click listeners for the toggle links.
function setupAuthToggleListeners() {
    const showSignupLink = document.getElementById('show-signup-link');
    const showSigninLink = document.getElementById('show-signin-link');

    if (showSignupLink) {
        showSignupLink.addEventListener('click', (e) => {
            e.preventDefault(); // Prevent the link from navigating
            toggleAuthView('signup');
        });
    }

    if (showSigninLink) {
        showSigninLink.addEventListener('click', (e) => {
            e.preventDefault(); // Prevent the link from navigating
            toggleAuthView('signin');
        });
    }
}

// This is a global function that can be called from other scripts (like signin.js)
// to programmatically switch to the signup view and pre-fill data.
window.showSignupForm = function(prefillData = {}) {
    toggleAuthView('signup');

    const nameInput = document.getElementById('cus-name');
    const emailInput = document.getElementById('cus-email');
    const statusDiv = document.getElementById('mpwr-status');

    if (prefillData.name && nameInput) {
        nameInput.value = prefillData.name;
    }
    if (prefillData.email && emailInput) {
        emailInput.value = prefillData.email;
    }
    if (prefillData.message && statusDiv) {
        statusDiv.textContent = prefillData.message;
    }
}

// Run the setup function once the DOM is fully loaded.
document.addEventListener('DOMContentLoaded', setupAuthToggleListeners);